import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=d0c7a258"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c7a258')) {
      api.createRecord('d0c7a258', component.options)
    } else {
      api.reload('d0c7a258', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=d0c7a258", function () {
      api.rerender('d0c7a258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Account.vue"
export default component.exports